const buildResetActiveCompanyScopeState = ({ state, initialState }) => {
  return {
    ...initialState,
    local: {
      ...(state?.local || initialState.local)
    },
    openDestinationOptions: Array.isArray(state?.openDestinationOptions) ? state.openDestinationOptions : initialState.openDestinationOptions
  };
};

export default buildResetActiveCompanyScopeState;
